<div *ngIf="isLoading" class="loading-overlay">
  <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
</div>

<div *ngIf="!isLoading" class="request-doc-form-container">
  <div class="email-banner">
    <div class="container">
      <div class="email-frame-wrapper">
        <img
          src="https://res.cloudinary.com/deczpivjm/image/upload/v1757650063/SVG_Header_nqkm5i_m2gubm.svg"
          alt="Brand header frame"
          class="email-frame"
          loading="lazy"
          decoding="async"
          fetchpriority="low"
        />

        <div class="banner-brand">
          <img
            src="https://res.cloudinary.com/deczpivjm/image/upload/v1757656981/Group_3_aqpy43.png"
            alt="Company logo"
            class="banner-logo"
            loading="lazy"
            decoding="async"
          />
          <div class="banner-welcome">Welcome,</div>
        </div>

        <div class="banner-contacts">
          <a
            class="contact-row"
            [href]="helpUrl || 'https://www.example.com/support'"
            target="_blank"
            rel="noopener noreferrer"
          >
            Need a Help?
          </a>

          <a
            class="contact-row"
            [href]="'tel:' + (supportPhone || '+94712345678')"
            aria-label="Call support"
          >
            <mat-icon aria-hidden="true">phone_outline</mat-icon>
            <span>{{ supportPhone || '+94 71 234 5678' }}</span>
          </a>

          <a
            class="contact-row"
            [href]="'mailto:' + (supportEmail || 'support@email.com')"
            aria-label="Email support"
          >
            <mat-icon aria-hidden="true">mail_outline</mat-icon>
            <span>{{ supportEmail || 'Support@email.com' }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row mb-3" style="justify-content: center">
      <div class="col-12 mb-3">
        <mat-card class="p-1">
          <mat-card-title-group class="p-4">
            <mat-card-title
              mat-dialog-title
              class="d-flex align-items-center mb-1"
            >
              <div style="font-weight: 500">
                {{ 'Upload Requested Document' }}
              </div>
              <div class="request-id">
                Request ID: <span class="id-value">#356371</span>
              </div>
            </mat-card-title>
            <div
              class="request-header d-flex justify-content-between align-items-center mb-3"
            >
              <div class="submission-countdown">
                Submission link expires in:
                <span class="countdown-timer">{{ countdown$ | async }}</span>
              </div>
            </div>
            <mat-card-subtitle>
              {{
                'Upload the document as requested by the administrator for verification.'
              }}
            </mat-card-subtitle>
          </mat-card-title-group>

          <mat-divider></mat-divider>

          <mat-card-content class="pt-4 px-4">
            <form [formGroup]="documentCollectionFormData">
              <!-- Message when no external collection fields found -->
              <div
                *ngIf="
                  getEnrichedValueData().length === 0 &&
                  virtualModuleData?.value?.length > 0
                "
                class="no-external-fields-message mb-4"
              >
                <p class="text-muted">
                  No fields configured for external collection in this form.
                </p>
              </div>

              <!-- Dynamic Form Fields Section -->
              <div
                *ngIf="getEnrichedValueData().length > 0"
                class="form-fields-section mb-4"
              >
                <div class="form-fields-container">
                  <div
                    *ngFor="
                      let enrichedItem of getEnrichedValueData();
                      let i = index;
                      trackBy: trackByFormControlName
                    "
                    class="form-field-wrapper mb-3"
                  >
                    <ng-container [ngSwitch]="enrichedItem.enrichedData.type">
                      <!-- SHORT_ANSWER -->
                      <ng-container *ngSwitchCase="'SHORT_ANSWER'">
                        <app-short-answers
                          [shortAnswer]="
                            getShortAnswerData(enrichedItem.enrichedData)
                          "
                          [control]="enrichedItem.formControl"
                          (valueChange)="
                            onFormFieldValueChange($event, enrichedItem)
                          "
                        >
                        </app-short-answers>
                      </ng-container>

                      <!-- PARAGRAPH -->
                      <ng-container *ngSwitchCase="'PARAGRAPH'">
                        <app-paragraph
                          [paragraph]="
                            getParagraphData(enrichedItem.enrichedData)
                          "
                          [control]="enrichedItem.formControl"
                          (valueChange)="
                            onFormFieldValueChange($event, enrichedItem)
                          "
                        >
                        </app-paragraph>
                      </ng-container>

                      <!-- CHECKBOX -->
                      <ng-container *ngSwitchCase="'CHECKBOX'">
                        <app-checkbox-section
                          [field]="getCheckboxData(enrichedItem.enrichedData)"
                          [control]="enrichedItem.formControl"
                          (valueChange)="
                            onFormFieldValueChange($event, enrichedItem)
                          "
                        >
                        </app-checkbox-section>
                      </ng-container>

                      <!-- RADIO_BUTTON -->
                      <ng-container *ngSwitchCase="'RADIO_BUTTON'">
                        <app-radio-section
                          [field]="
                            getRadioButtonData(enrichedItem.enrichedData)
                          "
                          [control]="enrichedItem.formControl"
                          (valueChange)="
                            onFormFieldValueChange($event, enrichedItem)
                          "
                        >
                        </app-radio-section>
                      </ng-container>

                      <!-- DROPDOWN -->
                      <ng-container *ngSwitchCase="'DROPDOWN'">
                        <app-drop-down
                          [dropDown]="
                            getDropdownData(enrichedItem.enrichedData)
                          "
                          [control]="enrichedItem.formControl"
                          [externalToken]="externalToken"
                          (valueChange)="
                            onFormFieldValueChange($event, enrichedItem)
                          "
                        >
                        </app-drop-down>
                      </ng-container>

                      <!-- DATE_TIME -->
                      <ng-container *ngSwitchCase="'DATE_TIME'">
                        <app-date-time
                          [dateTime]="
                            getDateTimeData(enrichedItem.enrichedData)
                          "
                          [control]="enrichedItem.formControl"
                          (valueChange)="
                            onFormFieldValueChange($event, enrichedItem)
                          "
                        >
                        </app-date-time>
                      </ng-container>

                      <!-- DATE -->
                      <ng-container *ngSwitchCase="'DATE'">
                        <app-date
                          [date]="getDateData(enrichedItem.enrichedData)"
                          [control]="enrichedItem.formControl"
                          (valueChange)="
                            onFormFieldValueChange($event, enrichedItem)
                          "
                        >
                        </app-date>
                      </ng-container>

                      <!-- TIME -->
                      <ng-container *ngSwitchCase="'TIME'">
                        <app-time
                          [time]="getTimeData(enrichedItem.enrichedData)"
                          [control]="enrichedItem.formControl"
                          (valueChange)="
                            onFormFieldValueChange($event, enrichedItem)
                          "
                        >
                        </app-time>
                      </ng-container>

                      <!-- EMAIL -->
                      <ng-container *ngSwitchCase="'EMAIL'">
                        <app-section-email
                          [sectionName]="
                            getEmailData(enrichedItem.enrichedData)
                          "
                          [value]="enrichedItem.formControl.value"
                          (setValue)="enrichedItem.formControl.setValue($event)"
                        >
                        </app-section-email>
                      </ng-container>

                      <!-- NUMBER -->
                      <ng-container *ngSwitchCase="'NUMBER'">
                        <app-number-section
                          [numberSection]="
                            getNumberData(enrichedItem.enrichedData)
                          "
                          [control]="enrichedItem.formControl"
                          (valueChange)="
                            onFormFieldValueChange($event, enrichedItem)
                          "
                        >
                        </app-number-section>
                      </ng-container>

                      <!-- CONTACT_NUMBER -->
                      <ng-container *ngSwitchCase="'CONTACT_NUMBER'">
                        <app-section-contact-number
                          [contactNumber]="
                            getContactNumberData(enrichedItem.enrichedData)
                          "
                          [value]="enrichedItem.formControl.value"
                          (setValue)="enrichedItem.formControl.setValue($event)"
                        >
                        </app-section-contact-number>
                      </ng-container>

                      <!-- NAME -->
                      <ng-container *ngSwitchCase="'NAME'">
                        <app-section-name
                          [sectionName]="getNameData(enrichedItem.enrichedData)"
                          [value]="enrichedItem.formControl.value"
                          (setValue)="enrichedItem.formControl.setValue($event)"
                        >
                        </app-section-name>
                      </ng-container>

                      <!-- ADDRESS -->
                      <ng-container *ngSwitchCase="'ADDRESS'">
                        <app-section-address
                          [sectionName]="
                            getAddressData(enrichedItem.enrichedData)
                          "
                          [value]="enrichedItem.formControl.value"
                          (setValue)="enrichedItem.formControl.setValue($event)"
                        >
                        </app-section-address>
                      </ng-container>

                      <!-- UPLOAD_FIELD -->
                      <ng-container *ngSwitchCase="'UPLOAD_FIELD'">
                        <div class="upload-field-section mb-4">
                          <mat-accordion>
                            <mat-expansion-panel class="upload-expansion-panel">
                              <mat-expansion-panel-header>
                                <mat-panel-title
                                  class="d-flex align-items-center justify-content-between p-2 w-100 content__header panel-header-left"
                                >
                                  <div
                                    class="d-flex align-items-center panel-left"
                                  >
                                    <div class="header-text">
                                      <div class="title-text">
                                        {{ enrichedItem.enrichedData.title }}
                                        <span
                                          *ngIf="
                                            enrichedItem.enrichedData.isRequired
                                          "
                                          class="text-danger"
                                          >*</span
                                        >
                                      </div>
                                      <div
                                        class="subtitle-text"
                                        *ngIf="
                                          enrichedItem.enrichedData.subTitle
                                        "
                                      >
                                        {{ enrichedItem.enrichedData.subTitle }}
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="d-flex align-items-center panel-right"
                                  ></div>
                                </mat-panel-title>
                              </mat-expansion-panel-header>

                              <mat-divider
                                style="margin-bottom: 35px"
                              ></mat-divider>

                              <div class="col-md-12 mb-3">
                                <app-drag-and-drop
                                  style="width: 100%"
                                  [allowUpload]="
                                    shouldAllowUpload(
                                      enrichedItem.enrichedData,
                                      'UPLOAD_FIELD_' +
                                        enrichedItem.enrichedData
                                          .formControlName
                                    )
                                  "
                                  [allowDelete]="false"
                                  [uploadDirectly]="false"
                                  [displayImg]="true"
                                  [allowedTypesRegex]="
                                    getAllowedTypesRegex(
                                      enrichedItem.enrichedData
                                        .allowed_file_types
                                    )
                                  "
                                  [allowedTypesNames]="
                                    getAllowedTypesNames(
                                      enrichedItem.enrichedData
                                        .allowed_file_types
                                    )
                                  "
                                  (triggerFileSelected)="
                                    triggerFileSelected(
                                      $event,
                                      'UPLOAD_FIELD_' +
                                        enrichedItem.enrichedData
                                          .formControlName
                                    )
                                  "
                                  [maxSize]="
                                    enrichedItem.enrichedData
                                      .maximum_file_size || 5
                                  "
                                  [remainingFilesCount]="
                                    enrichedItem.enrichedData.isMultipleUpload
                                      ? 10
                                      : 1
                                  "
                                ></app-drag-and-drop>

                                <app-display-data-in-dlt
                                  *ngIf="
                                    documentUploadData[
                                      'UPLOAD_FIELD_' +
                                        enrichedItem.enrichedData
                                          .formControlName
                                    ]?.dataList?.length > 0
                                  "
                                  [totalCount]="
                                    documentUploadData[
                                      'UPLOAD_FIELD_' +
                                        enrichedItem.enrichedData
                                          .formControlName
                                    ]?.dataList?.length
                                  "
                                  [dataListArray]="
                                    documentUploadData[
                                      'UPLOAD_FIELD_' +
                                        enrichedItem.enrichedData
                                          .formControlName
                                    ]?.dataList
                                  "
                                  (onClickAction)="
                                    action(
                                      $event,
                                      'UPLOAD_FIELD_' +
                                        enrichedItem.enrichedData
                                          .formControlName
                                    )
                                  "
                                ></app-display-data-in-dlt>
                              </div>
                            </mat-expansion-panel>
                          </mat-accordion>
                        </div>
                      </ng-container>

                      <!-- DOCUMENT_REQUEST -->
                      <ng-container *ngSwitchCase="'DOCUMENT_REQUEST'">
                        <div
                          class="document-request-section mb-4"
                          *ngIf="
                            getDocumentRequestDocuments(
                              enrichedItem.enrichedData
                            ).length > 0
                          "
                        >
                          <mat-accordion [multi]="true">
                            <!-- Main Document Request Header -->
                            <mat-expansion-panel
                              class="document-request-expansion-panel"
                            >
                              <mat-expansion-panel-header>
                                <mat-panel-title
                                  class="d-flex align-items-center justify-content-between p-2 w-100 content__header panel-header-left"
                                >
                                  <div
                                    class="d-flex align-items-center panel-left"
                                  >
                                    <div class="header-text">
                                      <div class="title-text">
                                        {{ enrichedItem.enrichedData.title }}
                                        <span
                                          *ngIf="
                                            enrichedItem.enrichedData.isRequired
                                          "
                                          class="text-danger"
                                          >*</span
                                        >
                                      </div>
                                      <div
                                        class="subtitle-text"
                                        *ngIf="
                                          enrichedItem.enrichedData.subTitle
                                        "
                                      >
                                        {{ enrichedItem.enrichedData.subTitle }}
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="d-flex align-items-center panel-right"
                                  ></div>
                                </mat-panel-title>
                              </mat-expansion-panel-header>

                              <mat-divider
                                style="margin-bottom: 35px"
                              ></mat-divider>

                              <!-- Loop through each document in the document request -->
                              <div
                                *ngFor="
                                  let document of getDocumentRequestDocuments(
                                    enrichedItem.enrichedData
                                  );
                                  let docIndex = index
                                "
                                class="document-request-item mb-3"
                              >
                                <mat-expansion-panel
                                  class="nested-document-panel"
                                >
                                  <mat-expansion-panel-header>
                                    <mat-panel-title
                                      class="d-flex align-items-center justify-content-between p-2 w-100"
                                    >
                                      <div class="d-flex align-items-center">
                                        <div class="header-text">
                                          <div class="title-text">
                                            {{ document.name }}
                                            <span
                                              *ngIf="document.isRequired"
                                              class="text-danger ml-1"
                                              >*</span
                                            >
                                          </div>
                                          <div
                                            class="subtitle-text"
                                            *ngIf="document.description"
                                          >
                                            {{ document.description }}
                                          </div>
                                        </div>
                                      </div>
                                    </mat-panel-title>
                                  </mat-expansion-panel-header>

                                  <mat-divider
                                    style="margin-bottom: 20px"
                                  ></mat-divider>

                                  <div class="document-upload-info mb-2">
                                    <small class="text-muted">
                                      Max size:
                                      {{ document.maximum_file_size }}MB |
                                      Allowed types:
                                      {{
                                        document.allowed_file_types?.join(', ')
                                      }}
                                      <span *ngIf="!document.isMultipleUpload">
                                        | Single file only</span
                                      >
                                    </small>
                                  </div>

                                  <div class="col-md-12 mb-3">
                                    <div
                                      *ngIf="
                                        virtualModuleData.status !==
                                          'Approved' &&
                                        virtualModuleData.status !== 'Rejected'
                                      "
                                    >
                                      <app-drag-and-drop
                                        style="width: 100%"
                                        [allowUpload]="
                                          shouldAllowUpload(
                                            document,
                                            'DOC_REQ_' +
                                              enrichedItem.enrichedData
                                                .formControlName +
                                              '_' +
                                              docIndex
                                          )
                                        "
                                        [allowDelete]="false"
                                        [uploadDirectly]="false"
                                        [displayImg]="true"
                                        [allowedTypesRegex]="
                                          getAllowedTypesRegex(
                                            document.allowed_file_types
                                          )
                                        "
                                        [allowedTypesNames]="
                                          getAllowedTypesNames(
                                            document.allowed_file_types
                                          )
                                        "
                                        (triggerFileSelected)="
                                          triggerFileSelected(
                                            $event,
                                            'DOC_REQ_' +
                                              enrichedItem.enrichedData
                                                .formControlName +
                                              '_' +
                                              docIndex
                                          )
                                        "
                                        [maxSize]="
                                          document.maximum_file_size || 5
                                        "
                                        [remainingFilesCount]="
                                          document.isMultipleUpload ? 10 : 1
                                        "
                                      ></app-drag-and-drop>
                                    </div>

                                    <app-display-data-in-dlt
                                      *ngIf="
                                        documentUploadData[
                                          'DOC_REQ_' +
                                            enrichedItem.enrichedData
                                              .formControlName +
                                            '_' +
                                            docIndex
                                        ]?.dataList?.length > 0
                                      "
                                      [totalCount]="
                                        documentUploadData[
                                          'DOC_REQ_' +
                                            enrichedItem.enrichedData
                                              .formControlName +
                                            '_' +
                                            docIndex
                                        ]?.dataList?.length
                                      "
                                      [dataListArray]="
                                        documentUploadData[
                                          'DOC_REQ_' +
                                            enrichedItem.enrichedData
                                              .formControlName +
                                            '_' +
                                            docIndex
                                        ]?.dataList
                                      "
                                      (onClickAction)="
                                        action(
                                          $event,
                                          'DOC_REQ_' +
                                            enrichedItem.enrichedData
                                              .formControlName +
                                            '_' +
                                            docIndex
                                        )
                                      "
                                    ></app-display-data-in-dlt>
                                  </div>
                                </mat-expansion-panel>
                              </div>
                            </mat-expansion-panel>
                          </mat-accordion>
                        </div>
                      </ng-container>

                      <!-- Fallback for unknown types -->
                      <ng-container *ngSwitchDefault>
                        <div class="unknown-field-type p-3 border rounded">
                          <h6>
                            {{
                              enrichedItem.enrichedData.title || 'Unknown Field'
                            }}
                          </h6>
                          <p
                            *ngIf="enrichedItem.enrichedData.subTitle"
                            class="field-subtitle mb-2 text-muted"
                          >
                            {{ enrichedItem.enrichedData.subTitle }}
                          </p>
                          <p class="text-muted">
                            Field Type: {{ enrichedItem.enrichedData.type }}
                          </p>
                          <mat-form-field appearance="outline" class="w-100">
                            <mat-label>{{
                              enrichedItem.enrichedData.title
                            }}</mat-label>
                            <input
                              matInput
                              [formControl]="enrichedItem.formControl"
                              [placeholder]="
                                enrichedItem.enrichedData.placeholder || ''
                              "
                            />
                          </mat-form-field>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>

              <mat-card-actions class="d-flex justify-content-end flex-wrap">
                <button
                  id="btn-draft"
                  (click)="onSubmit('draft')"
                  data-testid="add_use_doc_btn_draft"
                  class="m-2"
                  mat-raised-button
                  color="basic"
                  [disabled]="areButtonsDisabled"
                >
                  {{ 'knowledgebase.article-actions.save-draft' | translate }}
                </button>
                <button
                  class="m-2"
                  (click)="onSubmit('save')"
                  data-testid="add_use_doc_btn_save"
                  mat-raised-button
                  color="primary"
                  [disabled]="isSaveButtonDisabled"
                >
                  {{ 'knowledgebase.article-actions.save' | translate }}
                </button>
              </mat-card-actions>
            </form>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
